import { Grid, Stack } from '@mui/material';

import {
  FormDateField,
  FormFieldReadOnlyValue,
  FormNumberField,
  FormRichTextField,
} from '../../../../../common';
import {
  TREATMENT_DURATION_MAX_MONTHS,
  TREATMENT_DURATION_MIN_MONTHS,
  TREATMENT_PROPOSED_START_DATE_FORMAT,
  TREATMENT_RICH_TEXT_MAX_LENGTH,
} from '../constants';
import TreatmentServicesList from './TreatmentServicesList';

import type { TreatmentFieldsProps } from './types';

export default function TreatmentFields({
  formik,
  disabled,
  isProvisioningRequired,
  readOnly,
  saveField,
  therapyProvisioningDescription,
}: TreatmentFieldsProps) {
  return (
    <Stack gap={2}>
      <FormRichTextField
        disabled={disabled}
        formik={formik}
        label="Recommendations explanation"
        maxLength={TREATMENT_RICH_TEXT_MAX_LENGTH}
        minHeight={80}
        name="recommendations_explanation"
        onBlur={saveField}
        readOnly={readOnly}
        required
      />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Stack gap={2}>
            <FormDateField
              disabled={disabled}
              formik={formik}
              format={TREATMENT_PROPOSED_START_DATE_FORMAT}
              label="Proposed start date"
              name="proposed_start_date"
              onChange={saveField}
              placeholder="Select proposed start date (give two weeks for approval)"
              readOnly={readOnly}
              required
            />
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Duration (months)"
              max={TREATMENT_DURATION_MAX_MONTHS}
              maxDecimalPlaces={0}
              min={TREATMENT_DURATION_MIN_MONTHS}
              name="duration_in_months"
              onBlur={saveField}
              placeholder="Enter number of months"
              readOnly={readOnly}
              required
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormFieldReadOnlyValue
            label="Therapy provisioning description"
            minRows={4}
            multiline
            placeholder="---"
            required={isProvisioningRequired}
            value={therapyProvisioningDescription ?? ''}
          />
        </Grid>
      </Grid>
      <TreatmentServicesList
        disabled={disabled}
        formik={formik}
        readOnly={readOnly}
        saveField={saveField}
      />
    </Stack>
  );
}
